module.exports = __webpack_public_path__ + "img/pr-44.c4e290e3.png";